export { StarRating } from './StarRating';



// WEBPACK FOOTER //
// ./src/vp-ui/components/StarRating/index.js